export default __webpack_public_path__ + "static/media/qr_m05.e78ea53d.jpg";